
<template>
  <v-container class="container">
    <v-card>
      <v-card-title>Envío de Correos Masivos a Periodistas</v-card-title>
      <v-card-text>
        <v-divider />
        <v-form ref="form" v-model="valid">
          <h5 class="mt-4">Detalles del Correo</h5>
          <v-divider class="mb-4" />

          <v-row>
            <v-col cols="12">
              <v-select
                v-model="formCorreo.grupoSelected"
                :items="grupos"
                item-value="id"
                item-text="nombre"
                label="Grupo de Receptores"
                outlined
                :rules="[required]"
                dense
                return-object
                @onChange
              />
            </v-col>
          </v-row>
          <label class="v-label theme--light">Casilla de Salida</label>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="formCorreo.grupoSelected.casillasalida"
                outlined
                :rules="[required]"
                dense
                disabled
              />
            </v-col>
          </v-row>
          <label class="v-label theme--light">Asunto</label>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="formCorreo.asunto"
                outlined
                :rules="[required]"
                dense
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <TrumbowygEditor
        v-model="formCorreo.cuerpoHtml"
        label="Cuerpo del Correo"
        :error="cuerpoError ? 'El cuerpo del correo es requerido' : ''"
        :placeholder="'Escriba el cuerpo del correo aquí...'"
        :config="editorConfig"
      />

              <div v-if="cuerpoError" class="v-messages error--text">El cuerpo del correo es requerido</div>
            </v-col>
          </v-row>

<!--          <h5 class="mt-4">Archivos Adjuntos</h5>
          <v-divider class="mb-4" />

          <v-row>
            <v-col cols="12">
              <v-file-input
                accept="*/*"
                label="Adjuntar archivos (máx. 5MB por archivo)"
                outlined
                dense
                multiple
                show-size
                counter
                :rules="[fileSize]"
                @change="handleFileUpload"
                :disabled="archivosSuperanLimite"
                :error-messages="archivosSuperanLimite ? 'El tamaño total de los archivos supera el límite de 5MB' : ''"
                ref="fileInput"
              />
              <small class="text-caption" :class="{'error&#45;&#45;text': archivosSuperanLimite}">
                Tamaño total: {{ (totalArchivosSize / 1000000).toFixed(2) }} MB / 5 MB
              </small>
            </v-col>
          </v-row>-->

<!--
          <v-row v-if="formCorreo.archivos.length > 0">
            <v-col cols="12">
              <v-list dense>
                <v-subheader>Archivos seleccionados</v-subheader>
                <v-list-item v-for="(archivo, index) in formCorreo.archivos" :key="index">
                  <v-list-item-content>
                    <v-list-item-title>{{ archivo.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ (archivo.size / 1000000).toFixed(2) }} MB</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="eliminarArchivo(index)">
                      <v-icon color="error">mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
-->

          <v-row class="mt-4">
            <v-col cols="6">
              <v-btn @click="limpiarFormulario()" class="mr-2">Limpiar Formulario</v-btn>
            </v-col>
            <v-col cols="6" class="d-flex justify-end">
              <v-btn
                color="primary"
                :disabled="!formValido || archivosSuperanLimite || loading"
                @click="enviarCorreos()"
              >
                Enviar Correos
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { Loading } from 'element-ui'
import Swal from "sweetalert2"
import { mapGetters } from "vuex"
import { EnvioCorreosService } from '../../util/Api/EnvioCorreos/calls'
import TrumbowygEditor from '@/components/TrumbowygEditor.vue'
import {EgresosService} from "../../util/Api/Egresos/calls";


export default {
  name: "EnvioCorreosComponent",
  components: {
    TrumbowygEditor
  },
  data() {
    return {
      valid: true,
      cuerpoError: false,
      required: (v) => !!v || "El campo es requerido",
      emailRequired: (v) => !!v || "El correo es requerido",
      fileSize: (v) => {
        if (!v) return true;
        if (Array.isArray(v)) {
          // Para múltiples archivos
          return v.every(file => file.size <= 5000000) || "El tamaño de cada archivo no debe superar los 5MB";
        }
        // Para un solo archivo
        return v.size <= 5000000 || "El tamaño del archivo no debe superar los 5MB";
      },
      maxFileSize: 5000000, // 5MB en bytes
      loading: false,
      editorConfig: {
        btns: [
          ['viewHTML'],
          ['undo', 'redo'],
          ['formatting'],
          ['foreColor'],
          ['fontfamily'],
          ['fontsize'],
          ['lineheight'],
          ['strong', 'em', 'del'],
          ['superscript', 'subscript'],
          ['link'],
          ['insertImage'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],

          ['fullscreen']
        ],
        plugins: {
          colors: {
            colorList: [
              'ED1C24', '000103', 'ffffff'
            ],
          },
          fontfamily: {
            fontList: [
              {name: 'Segoe UI', family: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif'},
              {name: 'Aptos Serif', family: '"Aptos Serif", serif'},
              {name: 'Roboto Regular', family: '"Roboto", "Roboto Regular", sans-serif'},
              {name: 'Sans Serif', family: 'sans-serif'},
              {name: 'StagSans Book', family: '"StagSans-Book", sans-serif'},
              {name: 'StagSans Light', family: '"StagSans-Light", sans-serif'},
              {name: 'StagSans Medium', family: '"StagSans-Medium", sans-serif'},
              {name: 'StagSans Semibold', family: '"StagSans-Semibold", sans-serif'},
              {name: 'Arial', family: 'Arial, Helvetica, sans-serif'},
              {name: 'Comic Sans', family: '\'Comic Sans MS\', Textile, cursive, sans-serif'},
              {name: 'Open Sans', family: '\'Open Sans\', sans-serif'}
            ]
          }
        },

        autogrow: true,
        removeformatPasted: true,
        lang: 'es',
        semantic: false
      },
      grupos: [],
      formCorreo: {
        grupoSelected: {id:null, nombre:null, casillasalida:null},
        asunto: "",
        cuerpoHtml: `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
</head>
<body style="margin:0; padding:0; font-family: Aptos, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, Helvetica, sans-serif; font-size:12pt; color:#000000; line-height:1.5; background-color:#F3F3F3;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color:#F3F3F3;">
    <tbody><tr>
      <td align="center">
        <table width="596" cellpadding="0" cellspacing="0" style="background-color:#FEFEFE;">
          <!-- Barra roja superior -->
          <tbody><tr>
            <td style="background-color:#D90915; height:40px; font-size:0; line-height:0;"></td>
          </tr>

          <!-- Logo -->
          <tr style="align:center;" "="">
            <td style="padding:50px 16px 50px 16px; align:center;" align="center">
              <img src="https://www.servel.cl/wp-content/uploads/elementor/thumbs/Logo-Servel_2-pz97n8j4o5tj23nw56d5wjjua63x90jaekks37yinw.png" alt="Logo Servel" style="display:block; max-width:100%; height:auto; margin:0 auto;">
            </td>
          </tr>

          <!-- Contenido principal -->
          <tr style="line-height: normal;">
            <td style="padding:8px 16px 50px 16px;"><p style="text-align: center;"><b style="color: rgb(0, 1, 3); font-family: Roboto, &quot;Roboto Regular&quot;, sans-serif; font-size: 0.875rem; letter-spacing: 0.00714286em;"><span style="font-size: 30px;">Titulo</span></b><span style="color: rgb(0, 1, 3); font-family: Roboto, &quot;Roboto Regular&quot;, sans-serif; letter-spacing: 0.00714286em; font-size: 32px;">&nbsp;</span></p><span style="color: rgb(0, 1, 3); font-family: Roboto, &quot;Roboto Regular&quot;, sans-serif;"><br><br><span style="font-size: medium;">Fecha<br><br><br>Contenido<br><br><br><br><br>.</span></span><!-- Contenido del correo --></td>
          </tr>

          <!-- Firma -->
          <tr>
            <td style="padding:8px 16px 16px 16px;">
              <table cellpadding="0" cellspacing="0" style="width:100%;">
                <tbody><tr>
                  <td width="61" valign="top">
                    <img src="https://www.servel.cl/wp-content/uploads/elementor/thumbs/Logo-Servel_2-pz97n8j4o5tj23nw56d5wjjua63x90jaekks37yinw.png" alt="Logo Footer" style="width:61px; height:auto; display:block;">
                  </td>
                  <td style="padding-left:8px;" valign="top">
                    <p style="margin:0; font-size:14px; line-height:1.4;">
                      Unidad de Comunicaciones<br>
                      Lorena Concha<br>
                      Tel. +56 9 92227461<br>
                      <a href="mailto:lconcha@servel.cl" target="_self">lconcha@servel.cl</a>,
                      <a href="mailto:comunicaciones@servel.cl" style="color:#0078D4; text-decoration:underline;">comunicaciones@servel.cl</a><br>
                      <strong><a href="https://www.servel.cl" target="_blank" style="color:#0078D4; text-decoration:underline;">www.servel.cl</a></strong>
                    </p>
                  </td>
                </tr>
              </tbody></table>
            </td>
          </tr>
          <!-- Barra roja inferior -->
          <tr>
            <td style="background-color:#D90915; height:40px; font-size:0; line-height:0;"></td>
          </tr>
        </tbody></table>
      </td>
    </tr>
  </tbody></table>
</body>
</html>

`,
        archivos: []
      }
    };
  },
  computed: {
    ...mapGetters(["getPerfil"]),
    formValido() {
      return (
        this.formCorreo.grupoSelected.casillasalida !== null &&
        this.formCorreo.asunto !== "" &&
        this.formCorreo.cuerpoHtml.trim() !== ""
      );
    },
    totalArchivosSize() {
      return this.formCorreo.archivos.reduce((total, archivo) => total + archivo.size, 0);
    },
    archivosSuperanLimite() {
      return this.totalArchivosSize > this.maxFileSize;
    }
  },
  mounted() {
    this.getGrupos()
    this.$nextTick(() => {
      if (window.$ && $.fn.trumbowyg) {
        console.log("EXISTE", this.$refs.editor)
        $(this.$refs.editor).trumbowyg({
          lang: 'es'
        }).on('tbwchange', () => {
          this.contenido = $(this.$refs.editor).trumbowyg('html')
        })
      } else {
        console.error('Trumbowyg no cargado correctamente')
      }
    })
  },
  methods: {

    async getGrupos(){
      try {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        });

        this.grupos = await EnvioCorreosService.getAllGrupos();
        this.loadingInstance.close();
      } catch (error) {
        this.loadingInstance.close();
        console.log("error", error);
        Swal.fire({
          type: "error",
          html: `Error al cargar los Grupos: ${error}`,
        });
      }
    },
    limpiarFormulario() {
      // Limpiar el formulario
      this.formCorreo = {
        grupoSelected: {id:null, nombre:null, casillasalida:null},
        asunto: "",
        cuerpoHtml: `<!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
    </head>
    <body style="margin:0; padding:0; font-family: Aptos, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, Helvetica, sans-serif; font-size:12pt; color:#000000; line-height:1.5; background-color:#F3F3F3;">
      <table width="100%" cellpadding="0" cellspacing="0" style="background-color:#F3F3F3;">
    <tbody><tr>
      <td align="center">
        <table width="596" cellpadding="0" cellspacing="0" style="background-color:#FEFEFE;">
          <!-- Barra roja superior -->
          <tbody><tr>
            <td style="background-color:#D90915; height:40px; font-size:0; line-height:0;"></td>
          </tr>

          <!-- Logo -->
          <tr style="align:center;" "="">
            <td style="padding:50px 16px 50px 16px; align:center;" align="center">
              <img src="https://www.servel.cl/wp-content/uploads/elementor/thumbs/Logo-Servel_2-pz97n8j4o5tj23nw56d5wjjua63x90jaekks37yinw.png" alt="Logo Servel" style="display:block; max-width:100%; height:auto; margin:0 auto;">
            </td>
          </tr>

          <!-- Contenido principal -->
          <tr style="line-height: normal;">
            <td style="padding:8px 16px 50px 16px;"><p style="text-align: center;"><b style="color: rgb(0, 1, 3); font-family: Roboto, &quot;Roboto Regular&quot;, sans-serif; font-size: 0.875rem; letter-spacing: 0.00714286em;"><span style="font-size: 30px;">Titulo</span></b><span style="color: rgb(0, 1, 3); font-family: Roboto, &quot;Roboto Regular&quot;, sans-serif; letter-spacing: 0.00714286em; font-size: 32px;">&nbsp;</span></p><span style="color: rgb(0, 1, 3); font-family: Roboto, &quot;Roboto Regular&quot;, sans-serif;"><br><br><span style="font-size: medium;">Fecha<br><br><br>Contenido<br><br><br><br><br>.</span></span><!-- Contenido del correo --></td>
          </tr>

          <!-- Firma -->
          <tr>
            <td style="padding:8px 16px 16px 16px;">
              <table cellpadding="0" cellspacing="0" style="width:100%;">
                <tbody><tr>
                  <td width="61" valign="top">
                    <img src="https://www.servel.cl/wp-content/uploads/elementor/thumbs/Logo-Servel_2-pz97n8j4o5tj23nw56d5wjjua63x90jaekks37yinw.png" alt="Logo Footer" style="width:61px; height:auto; display:block;">
                  </td>
                  <td style="padding-left:8px;" valign="top">
                    <p style="margin:0; font-size:14px; line-height:1.4;">
                      Unidad de Comunicaciones<br>
                      Lorena Concha<br>
                      Tel. +56 9 92227461<br>
                      <a href="mailto:lconcha@servel.cl" target="_self">lconcha@servel.cl</a>,
                      <a href="mailto:comunicaciones@servel.cl" style="color:#0078D4; text-decoration:underline;">comunicaciones@servel.cl</a><br>
                      <strong><a href="https://www.servel.cl" target="_blank" style="color:#0078D4; text-decoration:underline;">www.servel.cl</a></strong>
                    </p>
                  </td>
                </tr>
              </tbody></table>
            </td>
          </tr>
          <!-- Barra roja inferior -->
          <tr>
            <td style="background-color:#D90915; height:40px; font-size:0; line-height:0;"></td>
          </tr>
        </tbody></table>
      </td>
    </tr>
      </tbody></table>
    </body>
    </html>

    `,
        archivos: []
      };


      // Resetear errores específicos
      this.cuerpoError = false;

      // Resetear el componente de archivo si existe
      if (this.$refs.fileInput) {
        this.$refs.fileInput.validate();
      }
    },
    handleFileUpload(event) {
      const files = event.target.files;
      if (!files || files.length === 0) {
        return;
      }

      let archivosSuperanLimiteIndividual = false;
      let archivosValidos = [];

      // Verificar cada archivo individualmente
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (file.size > this.maxFileSize) {
          archivosSuperanLimiteIndividual = true;
          Swal.fire({
            type: 'error',
            title: 'Error',
            text: `El archivo ${file.name} supera el límite de 5MB permitido.`
          });
        } else {
          archivosValidos.push(file);
        }
      }

      // Verificar si el total de archivos supera el límite
      const nuevoTamanioTotal = this.totalArchivosSize + archivosValidos.reduce((total, archivo) => total + archivo.size, 0);
      if (nuevoTamanioTotal > this.maxFileSize) {
        Swal.fire({
          type: 'error',
          title: 'Error',
          text: 'El tamaño total de los archivos superaría el límite de 5MB.'
        });
      } else {
        // Agregar solo los archivos válidos
        archivosValidos.forEach(file => {
          this.formCorreo.archivos.push(file);
        });
      }

      // Limpiar el input para permitir seleccionar el mismo archivo nuevamente
      event.target.value = '';
    },
    eliminarArchivo(index) {
      this.formCorreo.archivos.splice(index, 1);
      // Resetear el error en el input de archivo si ya no superamos el límite
      if (this.$refs.fileInput && !this.archivosSuperanLimite) {
        this.$refs.fileInput.validate();
      }
    },

    convertirArchivoABase64(archivo) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(archivo);
        reader.onload = () => {
          // Obtener solo la parte base64 eliminando el prefijo data:tipo/subtipo;base64,
          const base64 = reader.result.split(',')[1];
          resolve(base64);
        };
        reader.onerror = error => reject(error);
      });
    },
    async enviarCorreos() {
      if (!this.formValido) {
        Swal.fire({
          type: 'error',
          title: 'Error',
          text: 'Por favor complete todos los campos requeridos.'
        });
        return;
      }

      // Verificar nuevamente el tamaño de los archivos antes de enviar
      if (this.totalArchivosSize > this.maxFileSize) {
        Swal.fire({
          type: 'error',
          title: 'Error',
          text: 'El tamaño total de los archivos adjuntos supera el límite de 5MB.'
        });
        return;
      }

      // Verificar que cada archivo individualmente no supere el límite
      const archivoGrande = this.formCorreo.archivos.find(archivo => archivo.size > this.maxFileSize);
      if (archivoGrande) {
        Swal.fire({
          type: 'error',
          title: 'Error',
          text: `El archivo ${archivoGrande.name} supera el límite de 5MB permitido.`
        });
        return;
      }

      try {
        this.loading = true;
        this.loadingInstance = Loading.service({ fullscreen: true, text: 'Enviando...', background: 'rgba(0, 0, 0, 0.8)' });

        // Crear objeto JSON para enviar al servidor
        const datosCorreo = {
          receptor: this.formCorreo.grupoSelected.id,
          emisor:this.formCorreo.grupoSelected.casillasalida,
          asunto: this.formCorreo.asunto,
          cuerpo: this.formCorreo.cuerpoHtml,
          archivos: []
        };

        // Convertir archivos a base64 para incluirlos en el JSON
        for (const archivo of this.formCorreo.archivos) {
          const base64 = await this.convertirArchivoABase64(archivo);
          datosCorreo.archivos.push({
            nombre: archivo.name,
            tipo: archivo.type,
            tamano: archivo.size,
            contenido: base64
          });
        }

        const respuesta = await EnvioCorreosService.EnvioCorreos(datosCorreo);
        if (respuesta.statusCode !== 200) {
          throw new Error(respuesta.msg || 'Error al enviar los correos');
        }

        this.loadingInstance.close();
        this.loading = false;
        Swal.fire({
          type: 'success',
          title: 'Éxito',
          text: 'Los correos han sido enviados correctamente.'
        });
        this.limpiarFormulario();
      } catch (error) {
        this.loadingInstance.close();
        this.loading = false;
        console.error('Error al enviar correos:', error);
        Swal.fire({
          type: 'error',
          title: 'Error',
          text: `Error al enviar los correos: ${error.message || error}`
        });
      }
    }
  }
};
</script>


<style scoped>
.container {
  text-align: start !important;
}

.v-list-item__action {
  margin: 0 0 0 8px !important;
}

.editor-container {
  margin-bottom: 16px;
}

.error--text {
  color: #ff5252 !important;
}

/* Asegurarse de que el editor se muestra correctamente en el tema */
::v-deep .trumbowyg-box {
  width: 100%;
  margin: 0;
  border-radius: 4px;
}

::v-deep .trumbowyg-editor {
  min-height: 250px;
}

::v-deep .trumbowyg-button-pane {
  background: #f5f5f5;
}
</style>
